module.exports = __webpack_public_path__ + "static/img/google.3142c90.png";